export const socialAuthorizationSuccessPartPath =
  '/social-authorization-success'
export const socialAuthorizationSuccessPath = `${socialAuthorizationSuccessPartPath}/:provider`
export const socialAuthorizationFailPath = '/social-authorization-fail'
export const socialAuthorizationFailFullPath = `${socialAuthorizationFailPath}/:provider`

export interface SocialProvider {
  provider: string
}
